/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetEmployeesByBranchDocument = gql`
    query GetEmployeesByBranch($companyId: Int!, $branchId: Int, $onlyActive: Boolean, $itemsPerPage: Int) {
  user(companyId: $companyId) {
    employee(companyId: $companyId) {
      id
    }
    company(id: $companyId) {
      id
      employees(
        itemsPerPage: $itemsPerPage
        onlyActive: $onlyActive
        branchId: $branchId
      ) {
        employees {
          id
          name
          surname
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployeesByBranchQuery__
 *
 * To run a query within a React component, call `useGetEmployeesByBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesByBranchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesByBranchQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      onlyActive: // value for 'onlyActive'
 *      itemsPerPage: // value for 'itemsPerPage'
 *   },
 * });
 */
export function useGetEmployeesByBranchQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables> & ({ variables: GetEmployeesByBranchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>(GetEmployeesByBranchDocument, options);
      }
export function useGetEmployeesByBranchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>(GetEmployeesByBranchDocument, options);
        }
export function useGetEmployeesByBranchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>(GetEmployeesByBranchDocument, options);
        }
export type GetEmployeesByBranchQueryHookResult = ReturnType<typeof useGetEmployeesByBranchQuery>;
export type GetEmployeesByBranchLazyQueryHookResult = ReturnType<typeof useGetEmployeesByBranchLazyQuery>;
export type GetEmployeesByBranchSuspenseQueryHookResult = ReturnType<typeof useGetEmployeesByBranchSuspenseQuery>;
export type GetEmployeesByBranchQueryResult = Apollo.QueryResult<GetEmployeesByBranchQuery, GetEmployeesByBranchQueryVariables>;
export const GetProductsForSaleDocument = gql`
    query GetProductsForSale($itemsPerPage: Int, $nameSkuBarcode: String, $stockStatus: String, $id: Int, $deleted: Boolean, $branchId: Int!, $companyId: Int!) {
  products(
    itemsPerPage: $itemsPerPage
    nameSkuBarcode: $nameSkuBarcode
    stockStatus: $stockStatus
    id: $id
    deleted: $deleted
    branchId: $branchId
    companyId: $companyId
  ) {
    items {
      id
      name
      brand
      sku
    }
  }
}
    `;

/**
 * __useGetProductsForSaleQuery__
 *
 * To run a query within a React component, call `useGetProductsForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsForSaleQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      nameSkuBarcode: // value for 'nameSkuBarcode'
 *      stockStatus: // value for 'stockStatus'
 *      id: // value for 'id'
 *      deleted: // value for 'deleted'
 *      branchId: // value for 'branchId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetProductsForSaleQuery(baseOptions: Apollo.QueryHookOptions<GetProductsForSaleQuery, GetProductsForSaleQueryVariables> & ({ variables: GetProductsForSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>(GetProductsForSaleDocument, options);
      }
export function useGetProductsForSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>(GetProductsForSaleDocument, options);
        }
export function useGetProductsForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>(GetProductsForSaleDocument, options);
        }
export type GetProductsForSaleQueryHookResult = ReturnType<typeof useGetProductsForSaleQuery>;
export type GetProductsForSaleLazyQueryHookResult = ReturnType<typeof useGetProductsForSaleLazyQuery>;
export type GetProductsForSaleSuspenseQueryHookResult = ReturnType<typeof useGetProductsForSaleSuspenseQuery>;
export type GetProductsForSaleQueryResult = Apollo.QueryResult<GetProductsForSaleQuery, GetProductsForSaleQueryVariables>;
export const GetStorageByProductIdSaleDocument = gql`
    query GetStorageByProductIdSale($itemsPerPage: Int, $stockStatus: String, $productId: Int, $deleted: Boolean, $branchId: Int!, $companyId: Int!) {
  products(
    itemsPerPage: $itemsPerPage
    stockStatus: $stockStatus
    id: $productId
    deleted: $deleted
    branchId: $branchId
    companyId: $companyId
  ) {
    items {
      id
      price
      unit {
        id
        name
      }
      units {
        id
        name
      }
      storageProductRelations(branchId: $branchId) {
        id
        storage {
          type {
            id
            name
          }
          id
          name
          deleted
        }
        quantity
        stockQuantity
        quantityForRender
      }
    }
  }
}
    `;

/**
 * __useGetStorageByProductIdSaleQuery__
 *
 * To run a query within a React component, call `useGetStorageByProductIdSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStorageByProductIdSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStorageByProductIdSaleQuery({
 *   variables: {
 *      itemsPerPage: // value for 'itemsPerPage'
 *      stockStatus: // value for 'stockStatus'
 *      productId: // value for 'productId'
 *      deleted: // value for 'deleted'
 *      branchId: // value for 'branchId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetStorageByProductIdSaleQuery(baseOptions: Apollo.QueryHookOptions<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables> & ({ variables: GetStorageByProductIdSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>(GetStorageByProductIdSaleDocument, options);
      }
export function useGetStorageByProductIdSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>(GetStorageByProductIdSaleDocument, options);
        }
export function useGetStorageByProductIdSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>(GetStorageByProductIdSaleDocument, options);
        }
export type GetStorageByProductIdSaleQueryHookResult = ReturnType<typeof useGetStorageByProductIdSaleQuery>;
export type GetStorageByProductIdSaleLazyQueryHookResult = ReturnType<typeof useGetStorageByProductIdSaleLazyQuery>;
export type GetStorageByProductIdSaleSuspenseQueryHookResult = ReturnType<typeof useGetStorageByProductIdSaleSuspenseQuery>;
export type GetStorageByProductIdSaleQueryResult = Apollo.QueryResult<GetStorageByProductIdSaleQuery, GetStorageByProductIdSaleQueryVariables>;
export const FindClientByPhoneOrEmailDocument = gql`
    query FindClientByPhoneOrEmail($companyId: Int!, $search: String) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      clients(search: $search, itemsPerPage: 10000) {
        clients {
          name
          email
          phone
        }
      }
    }
  }
}
    `;

/**
 * __useFindClientByPhoneOrEmailQuery__
 *
 * To run a query within a React component, call `useFindClientByPhoneOrEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindClientByPhoneOrEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindClientByPhoneOrEmailQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useFindClientByPhoneOrEmailQuery(baseOptions: Apollo.QueryHookOptions<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables> & ({ variables: FindClientByPhoneOrEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>(FindClientByPhoneOrEmailDocument, options);
      }
export function useFindClientByPhoneOrEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>(FindClientByPhoneOrEmailDocument, options);
        }
export function useFindClientByPhoneOrEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>(FindClientByPhoneOrEmailDocument, options);
        }
export type FindClientByPhoneOrEmailQueryHookResult = ReturnType<typeof useFindClientByPhoneOrEmailQuery>;
export type FindClientByPhoneOrEmailLazyQueryHookResult = ReturnType<typeof useFindClientByPhoneOrEmailLazyQuery>;
export type FindClientByPhoneOrEmailSuspenseQueryHookResult = ReturnType<typeof useFindClientByPhoneOrEmailSuspenseQuery>;
export type FindClientByPhoneOrEmailQueryResult = Apollo.QueryResult<FindClientByPhoneOrEmailQuery, FindClientByPhoneOrEmailQueryVariables>;
export const GetInfoCompanySaleDocument = gql`
    query GetInfoCompanySale($companyId: Int!) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      timeZone {
        id
        name
      }
      country {
        isoCode
      }
    }
  }
}
    `;

/**
 * __useGetInfoCompanySaleQuery__
 *
 * To run a query within a React component, call `useGetInfoCompanySaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInfoCompanySaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInfoCompanySaleQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetInfoCompanySaleQuery(baseOptions: Apollo.QueryHookOptions<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables> & ({ variables: GetInfoCompanySaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>(GetInfoCompanySaleDocument, options);
      }
export function useGetInfoCompanySaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>(GetInfoCompanySaleDocument, options);
        }
export function useGetInfoCompanySaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>(GetInfoCompanySaleDocument, options);
        }
export type GetInfoCompanySaleQueryHookResult = ReturnType<typeof useGetInfoCompanySaleQuery>;
export type GetInfoCompanySaleLazyQueryHookResult = ReturnType<typeof useGetInfoCompanySaleLazyQuery>;
export type GetInfoCompanySaleSuspenseQueryHookResult = ReturnType<typeof useGetInfoCompanySaleSuspenseQuery>;
export type GetInfoCompanySaleQueryResult = Apollo.QueryResult<GetInfoCompanySaleQuery, GetInfoCompanySaleQueryVariables>;
export const CalculateAmountAndCheckStockDocument = gql`
    query CalculateAmountAndCheckStock($branchId: Int!, $input: ProductSaleRowInput!) {
  productSaleRow(branchId: $branchId, input: $input) {
    unitId
    quantity
    isStockLimitExceeded
    price
    discount
    amount
  }
}
    `;

/**
 * __useCalculateAmountAndCheckStockQuery__
 *
 * To run a query within a React component, call `useCalculateAmountAndCheckStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculateAmountAndCheckStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculateAmountAndCheckStockQuery({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalculateAmountAndCheckStockQuery(baseOptions: Apollo.QueryHookOptions<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables> & ({ variables: CalculateAmountAndCheckStockQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>(CalculateAmountAndCheckStockDocument, options);
      }
export function useCalculateAmountAndCheckStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>(CalculateAmountAndCheckStockDocument, options);
        }
export function useCalculateAmountAndCheckStockSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>(CalculateAmountAndCheckStockDocument, options);
        }
export type CalculateAmountAndCheckStockQueryHookResult = ReturnType<typeof useCalculateAmountAndCheckStockQuery>;
export type CalculateAmountAndCheckStockLazyQueryHookResult = ReturnType<typeof useCalculateAmountAndCheckStockLazyQuery>;
export type CalculateAmountAndCheckStockSuspenseQueryHookResult = ReturnType<typeof useCalculateAmountAndCheckStockSuspenseQuery>;
export type CalculateAmountAndCheckStockQueryResult = Apollo.QueryResult<CalculateAmountAndCheckStockQuery, CalculateAmountAndCheckStockQueryVariables>;
export const CheckBookingForSaleDocument = gql`
    query CheckBookingForSale($companyId: Int!, $branchId: Int!, $bookingUuid: Uuid) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $branchId) {
        branches {
          storageProductRelationHistoryPaginated(
            bookingUuid: $bookingUuid
            action: "SALE"
          ) {
            entities {
              id
              booking {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCheckBookingForSaleQuery__
 *
 * To run a query within a React component, call `useCheckBookingForSaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckBookingForSaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckBookingForSaleQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useCheckBookingForSaleQuery(baseOptions: Apollo.QueryHookOptions<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables> & ({ variables: CheckBookingForSaleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>(CheckBookingForSaleDocument, options);
      }
export function useCheckBookingForSaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>(CheckBookingForSaleDocument, options);
        }
export function useCheckBookingForSaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>(CheckBookingForSaleDocument, options);
        }
export type CheckBookingForSaleQueryHookResult = ReturnType<typeof useCheckBookingForSaleQuery>;
export type CheckBookingForSaleLazyQueryHookResult = ReturnType<typeof useCheckBookingForSaleLazyQuery>;
export type CheckBookingForSaleSuspenseQueryHookResult = ReturnType<typeof useCheckBookingForSaleSuspenseQuery>;
export type CheckBookingForSaleQueryResult = Apollo.QueryResult<CheckBookingForSaleQuery, CheckBookingForSaleQueryVariables>;
export const SaleOperationForBookingDocument = gql`
    query SaleOperationForBooking($companyId: Int!, $branchId: Int!, $bookingUuid: Uuid) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branchesPaginated(id: $branchId) {
        branches {
          id
          storageProductRelationHistoryPaginated(
            bookingUuid: $bookingUuid
            action: "SALE"
          ) {
            entities {
              id
              date
              action
              booking {
                id
              }
              operationNumber
              relatedSaleHistories {
                id
                price
                discount
                amount
                operationUnit {
                  id
                  name
                }
                operationQuantity
                product {
                  id
                  name
                  brand
                  sku
                }
                storage {
                  id
                  name
                  type {
                    id
                    name
                  }
                }
              }
              isPaid
              paymentType
              comment
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSaleOperationForBookingQuery__
 *
 * To run a query within a React component, call `useSaleOperationForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSaleOperationForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSaleOperationForBookingQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      bookingUuid: // value for 'bookingUuid'
 *   },
 * });
 */
export function useSaleOperationForBookingQuery(baseOptions: Apollo.QueryHookOptions<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables> & ({ variables: SaleOperationForBookingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>(SaleOperationForBookingDocument, options);
      }
export function useSaleOperationForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>(SaleOperationForBookingDocument, options);
        }
export function useSaleOperationForBookingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>(SaleOperationForBookingDocument, options);
        }
export type SaleOperationForBookingQueryHookResult = ReturnType<typeof useSaleOperationForBookingQuery>;
export type SaleOperationForBookingLazyQueryHookResult = ReturnType<typeof useSaleOperationForBookingLazyQuery>;
export type SaleOperationForBookingSuspenseQueryHookResult = ReturnType<typeof useSaleOperationForBookingSuspenseQuery>;
export type SaleOperationForBookingQueryResult = Apollo.QueryResult<SaleOperationForBookingQuery, SaleOperationForBookingQueryVariables>;
export const InfoForSalesTooltipDocument = gql`
    query InfoForSalesTooltip($companyId: Int!, $branchId: Int, $uuid: Uuid) {
  user(companyId: $companyId) {
    company(id: $companyId) {
      branches(id: $branchId) {
        bookingsList(uuid: $uuid) {
          saleActionDate
          saleActionProductsAmount
        }
      }
    }
  }
}
    `;

/**
 * __useInfoForSalesTooltipQuery__
 *
 * To run a query within a React component, call `useInfoForSalesTooltipQuery` and pass it any options that fit your needs.
 * When your component renders, `useInfoForSalesTooltipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInfoForSalesTooltipQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      branchId: // value for 'branchId'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useInfoForSalesTooltipQuery(baseOptions: Apollo.QueryHookOptions<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables> & ({ variables: InfoForSalesTooltipQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>(InfoForSalesTooltipDocument, options);
      }
export function useInfoForSalesTooltipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>(InfoForSalesTooltipDocument, options);
        }
export function useInfoForSalesTooltipSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>(InfoForSalesTooltipDocument, options);
        }
export type InfoForSalesTooltipQueryHookResult = ReturnType<typeof useInfoForSalesTooltipQuery>;
export type InfoForSalesTooltipLazyQueryHookResult = ReturnType<typeof useInfoForSalesTooltipLazyQuery>;
export type InfoForSalesTooltipSuspenseQueryHookResult = ReturnType<typeof useInfoForSalesTooltipSuspenseQuery>;
export type InfoForSalesTooltipQueryResult = Apollo.QueryResult<InfoForSalesTooltipQuery, InfoForSalesTooltipQueryVariables>;
export const SaleProductsDocument = gql`
    mutation SaleProducts($branchId: Int!, $input: [StorageOperationInput!], $bookingUuid: Uuid, $employeeId: Int!) {
  saleProducts(
    branchId: $branchId
    input: $input
    bookingUuid: $bookingUuid
    employeeId: $employeeId
  ) {
    id
  }
}
    `;
export type SaleProductsMutationFn = Apollo.MutationFunction<SaleProductsMutation, SaleProductsMutationVariables>;

/**
 * __useSaleProductsMutation__
 *
 * To run a mutation, you first call `useSaleProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaleProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saleProductsMutation, { data, loading, error }] = useSaleProductsMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      input: // value for 'input'
 *      bookingUuid: // value for 'bookingUuid'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useSaleProductsMutation(baseOptions?: Apollo.MutationHookOptions<SaleProductsMutation, SaleProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaleProductsMutation, SaleProductsMutationVariables>(SaleProductsDocument, options);
      }
export type SaleProductsMutationHookResult = ReturnType<typeof useSaleProductsMutation>;
export type SaleProductsMutationResult = Apollo.MutationResult<SaleProductsMutation>;
export type SaleProductsMutationOptions = Apollo.BaseMutationOptions<SaleProductsMutation, SaleProductsMutationVariables>;
export const UpdateSaleProductsDocument = gql`
    mutation UpdateSaleProducts($branchId: Int!, $employeeId: Int!, $input: [UpdateSaleProductsContainerInput!]) {
  updateSaleProducts(branchId: $branchId, employeeId: $employeeId, input: $input)
}
    `;
export type UpdateSaleProductsMutationFn = Apollo.MutationFunction<UpdateSaleProductsMutation, UpdateSaleProductsMutationVariables>;

/**
 * __useUpdateSaleProductsMutation__
 *
 * To run a mutation, you first call `useUpdateSaleProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaleProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaleProductsMutation, { data, loading, error }] = useUpdateSaleProductsMutation({
 *   variables: {
 *      branchId: // value for 'branchId'
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSaleProductsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaleProductsMutation, UpdateSaleProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaleProductsMutation, UpdateSaleProductsMutationVariables>(UpdateSaleProductsDocument, options);
      }
export type UpdateSaleProductsMutationHookResult = ReturnType<typeof useUpdateSaleProductsMutation>;
export type UpdateSaleProductsMutationResult = Apollo.MutationResult<UpdateSaleProductsMutation>;
export type UpdateSaleProductsMutationOptions = Apollo.BaseMutationOptions<UpdateSaleProductsMutation, UpdateSaleProductsMutationVariables>;
export type GetEmployeesByBranchQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  onlyActive?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetEmployeesByBranchQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', employee?: { __typename?: 'EmployeeProxy', id: number } | null, company?: { __typename?: 'CompanyProxy', id: number, employees?: { __typename?: 'EmployeePaginated', employees?: Array<{ __typename?: 'EmployeeProxy', id: number, name?: string | null, surname?: string | null }> | null } | null } | null } | null };

export type GetProductsForSaleQueryVariables = Types.Exact<{
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  nameSkuBarcode?: Types.InputMaybe<Types.Scalars['String']['input']>;
  stockStatus?: Types.InputMaybe<Types.Scalars['String']['input']>;
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  branchId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetProductsForSaleQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPaginated', items?: Array<{ __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null }> | null } | null };

export type GetStorageByProductIdSaleQueryVariables = Types.Exact<{
  itemsPerPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  stockStatus?: Types.InputMaybe<Types.Scalars['String']['input']>;
  productId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  deleted?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  branchId: Types.Scalars['Int']['input'];
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetStorageByProductIdSaleQuery = { __typename?: 'Query', products?: { __typename?: 'ProductPaginated', items?: Array<{ __typename?: 'ProductProxy', id: number, price: string, unit?: { __typename?: 'UnitProxy', id: number, name: string } | null, units?: Array<{ __typename?: 'UnitProxy', id: number, name: string }> | null, storageProductRelations?: Array<{ __typename?: 'StorageProductRelationProxy', id?: number | null, quantity?: any | null, stockQuantity?: string | null, quantityForRender?: string | null, storage?: { __typename?: 'StorageProxy', id: number, name: string, deleted: boolean, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null } | null }> | null }> | null } | null };

export type FindClientByPhoneOrEmailQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FindClientByPhoneOrEmailQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', clients?: { __typename?: 'ClientPaginated', clients?: Array<{ __typename?: 'ClientProxy', name?: string | null, email?: string | null, phone?: string | null }> | null } | null } | null } | null };

export type GetInfoCompanySaleQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
}>;


export type GetInfoCompanySaleQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', timeZone?: { __typename?: 'TimeZoneProxy', id: number, name: string } | null, country?: { __typename?: 'CountryProxy', isoCode?: string | null } | null } | null } | null };

export type CalculateAmountAndCheckStockQueryVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  input: Types.ProductSaleRowInput;
}>;


export type CalculateAmountAndCheckStockQuery = { __typename?: 'Query', productSaleRow: { __typename?: 'ProductSaleRow', unitId: number, quantity: number, isStockLimitExceeded: boolean, price: number, discount?: number | null, amount?: number | null } };

export type CheckBookingForSaleQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  bookingUuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type CheckBookingForSaleQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', storageProductRelationHistoryPaginated?: { __typename?: 'StorageProductRelationHistoryPaginatedType', entities?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, booking?: { __typename?: 'BookingMainProxy', id: number } | null }> | null } | null }> | null } | null } | null } | null };

export type SaleOperationForBookingQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId: Types.Scalars['Int']['input'];
  bookingUuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type SaleOperationForBookingQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branchesPaginated?: { __typename?: 'BranchPaginated', branches?: Array<{ __typename?: 'BranchProxy', id: number, storageProductRelationHistoryPaginated?: { __typename?: 'StorageProductRelationHistoryPaginatedType', entities?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, date?: string | null, action?: Types.StorageProductRelationHistoryAction | null, operationNumber?: any | null, isPaid?: boolean | null, paymentType?: string | null, comment?: string | null, booking?: { __typename?: 'BookingMainProxy', id: number } | null, relatedSaleHistories?: Array<{ __typename?: 'StorageProductRelationHistoryProxy', id: number, price: string, discount?: number | null, amount?: string | null, operationQuantity?: number | null, operationUnit?: { __typename?: 'UnitProxy', id: number, name: string } | null, product?: { __typename?: 'ProductProxy', id: number, name: string, brand?: string | null, sku?: string | null } | null, storage?: { __typename?: 'StorageProxy', id: number, name: string, type?: { __typename?: 'StorageTypeProxy', id: number, name: string } | null } | null }> | null }> | null } | null }> | null } | null } | null } | null };

export type InfoForSalesTooltipQueryVariables = Types.Exact<{
  companyId: Types.Scalars['Int']['input'];
  branchId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  uuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
}>;


export type InfoForSalesTooltipQuery = { __typename?: 'Query', user?: { __typename?: 'UserProxy', company?: { __typename?: 'CompanyProxy', branches?: Array<{ __typename?: 'BranchProxy', bookingsList?: Array<{ __typename?: 'BookingMainProxy', saleActionDate?: string | null, saleActionProductsAmount?: number | null }> | null }> | null } | null } | null };

export type SaleProductsMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  input?: Types.InputMaybe<Array<Types.StorageOperationInput> | Types.StorageOperationInput>;
  bookingUuid?: Types.InputMaybe<Types.Scalars['Uuid']['input']>;
  employeeId: Types.Scalars['Int']['input'];
}>;


export type SaleProductsMutation = { __typename?: 'Mutation', saleProducts?: Array<{ __typename?: 'StorageProductRelationProxy', id?: number | null }> | null };

export type UpdateSaleProductsMutationVariables = Types.Exact<{
  branchId: Types.Scalars['Int']['input'];
  employeeId: Types.Scalars['Int']['input'];
  input?: Types.InputMaybe<Array<Types.UpdateSaleProductsContainerInput> | Types.UpdateSaleProductsContainerInput>;
}>;


export type UpdateSaleProductsMutation = { __typename?: 'Mutation', updateSaleProducts: boolean };
